/** Encode expressions in a tagged template for safe inclusion within HTML */
export default function htmlEncodeTemplateLiteral(
	stringLiterals: TemplateStringsArray,
	...resolvedExpressions: unknown[]
) {
	// Initialize
	let constructedString = '';
	
	
	// Define type
	type EncodeNotNeededPiece = { dontEncode: boolean; text: string };
	
	
	// Append to output one key & optional value at a time
	for (const [index, stringLiteral] of stringLiterals.entries()) {
		// Append the string literal portion
		constructedString += stringLiteral;
		
		
		// Add related expression if available
		if (index < resolvedExpressions.length) {
			const unidentifiedPiece = resolvedExpressions[index];
			
			if (
				unidentifiedPiece !== null &&
				typeof unidentifiedPiece === 'object' &&
				'dontEncode' in unidentifiedPiece &&
				'text' in unidentifiedPiece
			) {
				const candidatePiece = unidentifiedPiece as EncodeNotNeededPiece;
				
				if (candidatePiece.dontEncode === true && typeof candidatePiece.text === 'string') {
					constructedString += candidatePiece.text;
					continue;
				}
			}
			
			constructedString += encodeSpecialHTMLCharacters(String(unidentifiedPiece));
		}
	}
	
	
	// Return
	return constructedString.trim();
}


// Helper function to perform the encoding
//  -> Based on: https://stackoverflow.com/a/57448862/1250940
function encodeSpecialHTMLCharacters(str: string) {
	interface Lookup {
		[character: string]: string;
	}
	
	const lookup: Lookup = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		"'": '&#39;',
		'"': '&quot;',
	};
	
	return str.replace(/[&<>'"]/g, (character) => lookup[character]);
}
